import { stmtAddPlugin, stmtAddPreview, stmtAddPreviewField, stmtAddReadoutField, stmtAddRelation, stmtAddSchemaColumn, stmtAddStructureColumn, stmtAddStructureField, stmtAddStructurePlugin, stmtCreateEntity, stmtCreateForm, stmtCreateInsideSelectForm, stmtCreateNavigation, stmtCreateReadout, stmtCreateScope, stmtCreateView, stmtDefineClickEvent, stmtSetDefaultColumn, stmtSetUnique, } from '@contember-cloud/studio-dsl';
export const crmTemplate = {
    name: 'My awesome CRM',
    type: 'crm',
    isDownloadable: true,
    intent: 'CRM is designed to help businesses manage customer relationships, track sales, and improve customer service. It provides a centralized platform for storing customer data, managing interactions, and tracking sales performance.',
    specification: {
        create: {
            content: '',
        },
    },
    schema: {
        create: {
            dsl: `# Create entities
${stmtCreateEntity({ entityName: 'Company' })}
${stmtCreateEntity({ entityName: 'CompanyType' })}
${stmtCreateEntity({ entityName: 'Contact' })}
${stmtCreateEntity({ entityName: 'ContactType' })}
${stmtCreateEntity({ entityName: 'Country' })}
${stmtCreateEntity({ entityName: 'Deal' })}
${stmtCreateEntity({ entityName: 'DealStage' })}
${stmtCreateEntity({ entityName: 'Industry' })}
${stmtCreateEntity({ entityName: 'Lead' })}
${stmtCreateEntity({ entityName: 'Note' })}
${stmtCreateEntity({ entityName: 'Offer' })}
${stmtCreateEntity({ entityName: 'Source' })}
${stmtCreateEntity({ entityName: 'Status' })}
${stmtCreateEntity({ entityName: 'User' })}

# Add Company columns and relations
${stmtAddSchemaColumn({ entityName: 'Company', columnName: 'name', dataType: 'text', nullable: false })}
${stmtAddSchemaColumn({ entityName: 'Company', columnName: 'website', dataType: 'text' })}
${stmtAddSchemaColumn({ entityName: 'Company', columnName: 'amountInCents', dataType: 'number' })}
${stmtAddSchemaColumn({ entityName: 'Company', columnName: 'email', dataType: 'text' })}
${stmtAddSchemaColumn({ entityName: 'Company', columnName: 'phone', dataType: 'text' })}
${stmtAddRelation({
                owningEntity: 'Company',
                owningField: 'type',
                relationshipType: 'many to one',
                inverseEntity: 'CompanyType',
                inverseField: 'companies',
            })}
${stmtAddRelation({
                owningEntity: 'Company',
                owningField: 'industry',
                relationshipType: 'many to one',
                inverseEntity: 'Industry',
                inverseField: 'companies',
            })}
${stmtAddRelation({
                owningEntity: 'Company',
                owningField: 'contacts',
                relationshipType: 'one to many',
                inverseEntity: 'Contact',
                inverseField: 'company',
            })}
${stmtAddRelation({
                owningEntity: 'Company',
                owningField: 'deals',
                relationshipType: 'one to many',
                inverseEntity: 'Deal',
                inverseField: 'company',
            })}
${stmtAddRelation({
                owningEntity: 'Company',
                owningField: 'leads',
                relationshipType: 'one to many',
                inverseEntity: 'Lead',
                inverseField: 'company',
            })}

# Add CompanyType columns and relations
${stmtAddSchemaColumn({ entityName: 'CompanyType', columnName: 'name', dataType: 'text', nullable: false })}
${stmtSetUnique({ entityName: 'CompanyType', fields: ['name'] })}

# Add Contact columns and relations
${stmtAddSchemaColumn({ entityName: 'Contact', columnName: 'firstName', dataType: 'text' })}
${stmtAddSchemaColumn({ entityName: 'Contact', columnName: 'lastName', dataType: 'text' })}
${stmtAddSchemaColumn({ entityName: 'Contact', columnName: 'email', dataType: 'text' })}
${stmtAddSchemaColumn({ entityName: 'Contact', columnName: 'phone', dataType: 'text' })}
${stmtAddSchemaColumn({ entityName: 'Contact', columnName: 'birthdate', dataType: 'date' })}
${stmtAddRelation({
                owningEntity: 'Contact',
                owningField: 'type',
                relationshipType: 'many to one',
                inverseEntity: 'ContactType',
                inverseField: 'contacts',
            })}
${stmtAddRelation({
                owningEntity: 'Contact',
                owningField: 'source',
                relationshipType: 'many to one',
                inverseEntity: 'Source',
                inverseField: 'contacts',
            })}
${stmtAddRelation({
                owningEntity: 'Contact',
                owningField: 'status',
                relationshipType: 'many to one',
                inverseEntity: 'Status',
                inverseField: 'contacts',
            })}
${stmtAddRelation({
                owningEntity: 'Contact',
                owningField: 'company',
                relationshipType: 'many to one',
                inverseEntity: 'Company',
                inverseField: 'contacts',
            })}
${stmtAddRelation({
                owningEntity: 'Contact',
                owningField: 'notes',
                relationshipType: 'one to many',
                inverseEntity: 'Note',
                inverseField: 'contact',
            })}

# Add ContactType columns and relations
${stmtAddSchemaColumn({ entityName: 'ContactType', columnName: 'name', dataType: 'text', nullable: false })}
${stmtSetUnique({ entityName: 'ContactType', fields: ['name'] })}

# Add Country columns and relations
${stmtAddSchemaColumn({ entityName: 'Country', columnName: 'name', dataType: 'text', nullable: false })}
${stmtSetUnique({ entityName: 'Country', fields: ['name'] })}
${stmtAddRelation({
                owningEntity: 'Country',
                owningField: 'companies',
                relationshipType: 'one to many',
                inverseEntity: 'Company',
                inverseField: 'country',
            })}
${stmtAddRelation({
                owningEntity: 'Country',
                owningField: 'contacts',
                relationshipType: 'one to many',
                inverseEntity: 'Contact',
                inverseField: 'country',
            })}

# Add Deal columns and relations
${stmtAddSchemaColumn({ entityName: 'Deal', columnName: 'name', dataType: 'text', nullable: false })}
${stmtAddSchemaColumn({ entityName: 'Deal', columnName: 'amountInCents', dataType: 'number' })}
${stmtAddSchemaColumn({ entityName: 'Deal', columnName: 'probability', dataType: 'number' })}
${stmtAddSchemaColumn({ entityName: 'Deal', columnName: 'order', dataType: 'number', nullable: false })}
${stmtSetDefaultColumn({ entityName: 'Deal', columnName: 'order', defaultValue: 0 })}
${stmtAddRelation({
                owningEntity: 'Deal',
                owningField: 'lead',
                relationshipType: 'many to one',
                inverseEntity: 'Lead',
                inverseField: 'deals',
            })}
${stmtAddRelation({
                owningEntity: 'Deal',
                owningField: 'assignedTo',
                relationshipType: 'many to many',
                inverseEntity: 'User',
                inverseField: 'deals',
            })}
${stmtAddSchemaColumn({ entityName: 'Deal', columnName: 'details', dataType: 'text' })}
${stmtAddRelation({
                owningEntity: 'Deal',
                owningField: 'stage',
                relationshipType: 'many to one',
                inverseEntity: 'DealStage',
                inverseField: 'deals',
            })}
${stmtAddRelation({
                owningEntity: 'Deal',
                owningField: 'company',
                relationshipType: 'many to one',
                inverseEntity: 'Company',
                inverseField: 'deals',
            })}
${stmtAddRelation({
                owningEntity: 'Deal',
                owningField: 'contacts',
                relationshipType: 'many to many',
                inverseEntity: 'Contact',
                inverseField: 'deals',
            })}
${stmtAddRelation({
                owningEntity: 'Deal',
                owningField: 'notes',
                relationshipType: 'one to many',
                inverseEntity: 'Note',
                inverseField: 'deal',
            })}
${stmtAddRelation({
                owningEntity: 'Deal',
                owningField: 'offers',
                relationshipType: 'one to many',
                inverseEntity: 'Offer',
                inverseField: 'deal',
            })}
${stmtAddRelation({
                owningEntity: 'Deal',
                owningField: 'source',
                relationshipType: 'many to one',
                inverseEntity: 'Source',
                inverseField: 'deals',
            })}
${stmtAddPlugin({ entityName: 'Deal', fieldName: 'files', pluginName: 'files' })}
${stmtAddPlugin({
                entityName: 'Deal',
                pluginName: 'board',
                params: {
                    entities: 'Deal',
                    columns: 'stage.name',
                    columnsSortableBy: 'order',
                    discriminationField: 'stage',
                    sortableBy: 'order',
                    columnHeader: 'stage.name',
                    titleField: 'name',
                },
            })}

# Add DealStage columns and relations
${stmtAddSchemaColumn({ entityName: 'DealStage', columnName: 'name', dataType: 'text', nullable: false })}
${stmtAddSchemaColumn({ entityName: 'DealStage', columnName: 'order', dataType: 'number', nullable: false })}
${stmtSetDefaultColumn({ entityName: 'DealStage', columnName: 'order', defaultValue: 0 })}
${stmtSetUnique({ entityName: 'DealStage', fields: ['name'] })}

# Add Industry columns and relations
${stmtAddSchemaColumn({ entityName: 'Industry', columnName: 'name', dataType: 'text', nullable: false })}
${stmtSetUnique({ entityName: 'Industry', fields: ['name'] })}

# Add Lead columns and relations
${stmtAddSchemaColumn({ entityName: 'Lead', columnName: 'name', dataType: 'text', nullable: false })}
${stmtAddSchemaColumn({ entityName: 'Lead', columnName: 'email', dataType: 'text' })}
${stmtAddSchemaColumn({ entityName: 'Lead', columnName: 'amountInCents', dataType: 'number' })}
${stmtAddSchemaColumn({ entityName: 'Lead', columnName: 'details', dataType: 'string' })}
${stmtAddRelation({
                owningEntity: 'Lead',
                owningField: 'company',
                relationshipType: 'many to one',
                inverseEntity: 'Company',
                inverseField: 'leads',
            })}
${stmtAddRelation({
                owningEntity: 'Lead',
                owningField: 'contacts',
                relationshipType: 'many to many',
                inverseEntity: 'Contact',
                inverseField: 'leads',
            })}
${stmtAddRelation({
                owningEntity: 'Lead',
                owningField: 'source',
                relationshipType: 'many to one',
                inverseEntity: 'Source',
                inverseField: 'leads',
            })}
${stmtAddRelation({
                owningEntity: 'Lead',
                owningField: 'status',
                relationshipType: 'many to one',
                inverseEntity: 'Status',
                inverseField: 'leads',
            })}
${stmtAddRelation({
                owningEntity: 'Lead',
                owningField: 'offers',
                relationshipType: 'one to many',
                inverseEntity: 'Offer',
                inverseField: 'lead',
            })}
${stmtAddRelation({
                owningEntity: 'Lead',
                owningField: 'notes',
                relationshipType: 'one to many',
                inverseEntity: 'Note',
                inverseField: 'lead',
            })}
${stmtAddRelation({
                owningEntity: 'Lead',
                owningField: 'assignedTo',
                relationshipType: 'many to many',
                inverseEntity: 'User',
                inverseField: 'leads',
            })}
${stmtAddSchemaColumn({ entityName: 'Lead', columnName: 'order', dataType: 'number' })}
${stmtSetDefaultColumn({ entityName: 'Lead', columnName: 'order', defaultValue: 0 })}

# Add Note columns and relations
${stmtAddSchemaColumn({ entityName: 'Note', columnName: 'content', dataType: 'text' })}

# Add Offer columns and relations
${stmtAddSchemaColumn({ entityName: 'Offer', columnName: 'description', dataType: 'text' })}
${stmtAddSchemaColumn({ entityName: 'Offer', columnName: 'priceInCents', dataType: 'number' })}
${stmtAddSchemaColumn({ entityName: 'Offer', columnName: 'validUntil', dataType: 'date' })}

# Add Source columns and relations
${stmtAddSchemaColumn({ entityName: 'Source', columnName: 'name', dataType: 'text', nullable: false })}
${stmtSetUnique({ entityName: 'Source', fields: ['name'] })}

# Add Status columns and relations
${stmtAddSchemaColumn({ entityName: 'Status', columnName: 'name', dataType: 'text', nullable: false })}
${stmtSetUnique({ entityName: 'Status', fields: ['name'] })}

# Add User columns and relations
${stmtAddPlugin({ entityName: 'User', pluginName: 'person', fieldName: 'person' })}

`,
        },
    },
    structure: {
        create: {
            dsl: `
# Create views
${stmtCreateView({ viewName: 'CompanyList' })}
${stmtCreateView({ viewName: 'CompanyDetail' })}
${stmtCreateView({ viewName: 'CompanyCreate' })}
${stmtCreateView({ viewName: 'CompanyEdit' })}

${stmtCreateView({ viewName: 'ContactList' })}
${stmtCreateView({ viewName: 'ContactDetail' })}
${stmtCreateView({ viewName: 'ContactCreate' })}
${stmtCreateView({ viewName: 'ContactEdit' })}

${stmtCreateView({ viewName: 'DealList' })}
${stmtCreateView({ viewName: 'DealBoard' })}
${stmtCreateView({ viewName: 'DealDetail' })}
${stmtCreateView({ viewName: 'DealCreate' })}
${stmtCreateView({ viewName: 'DealEdit' })}

${stmtCreateView({ viewName: 'LeadList' })}
${stmtCreateView({ viewName: 'LeadBoard' })}
${stmtCreateView({ viewName: 'LeadDetail' })}
${stmtCreateView({ viewName: 'LeadCreate' })}
${stmtCreateView({ viewName: 'LeadEdit' })}

${stmtCreateView({ viewName: 'UserList' })}
${stmtCreateView({ viewName: 'UserEdit' })}
${stmtCreateView({ viewName: 'UserCreate' })}

${stmtCreateView({ viewName: 'CompanyTypes' })}
${stmtCreateView({ viewName: 'ContactTypes' })}
${stmtCreateView({ viewName: 'DealStages' })}
${stmtCreateView({ viewName: 'Industries' })}
${stmtCreateView({ viewName: 'Sources' })}
${stmtCreateView({ viewName: 'Statuses' })}
${stmtCreateView({ viewName: 'Countries' })}

# Create scopes
${stmtCreateScope({ scopeName: 'CompanyList', viewName: 'CompanyList', entityName: 'Company', scopeType: 'dataGrid' })}
${stmtCreateScope({
                scopeName: 'CompanyDetail',
                viewName: 'CompanyDetail',
                entityName: 'Company',
                scopeType: 'detail',
            })}
${stmtCreateScope({
                scopeName: 'CompanyCreate',
                viewName: 'CompanyCreate',
                entityName: 'Company',
                scopeType: 'create',
            })}
${stmtCreateScope({ scopeName: 'CompanyEdit', viewName: 'CompanyEdit', entityName: 'Company', scopeType: 'edit' })}

${stmtCreateScope({ scopeName: 'ContactList', viewName: 'ContactList', entityName: 'Contact', scopeType: 'dataGrid' })}
${stmtCreateScope({
                scopeName: 'ContactDetail',
                viewName: 'ContactDetail',
                entityName: 'Contact',
                scopeType: 'detail',
            })}
${stmtCreateScope({
                scopeName: 'ContactCreate',
                viewName: 'ContactCreate',
                entityName: 'Contact',
                scopeType: 'create',
            })}
${stmtCreateScope({ scopeName: 'ContactEdit', viewName: 'ContactEdit', entityName: 'Contact', scopeType: 'edit' })}

${stmtCreateScope({ scopeName: 'DealList', viewName: 'DealList', entityName: 'Deal', scopeType: 'dataGrid' })}
${stmtCreateScope({ scopeName: 'DealDetail', viewName: 'DealDetail', entityName: 'Deal', scopeType: 'detail' })}
${stmtCreateScope({ scopeName: 'DealCreate', viewName: 'DealCreate', entityName: 'Deal', scopeType: 'create' })}
${stmtCreateScope({ scopeName: 'DealEdit', viewName: 'DealEdit', entityName: 'Deal', scopeType: 'edit' })}

${stmtCreateScope({ scopeName: 'LeadList', viewName: 'LeadList', entityName: 'Lead', scopeType: 'dataGrid' })}
${stmtCreateScope({ scopeName: 'LeadDetail', viewName: 'LeadDetail', entityName: 'Lead', scopeType: 'detail' })}
${stmtCreateScope({ scopeName: 'LeadCreate', viewName: 'LeadCreate', entityName: 'Lead', scopeType: 'create' })}
${stmtCreateScope({ scopeName: 'LeadEdit', viewName: 'LeadEdit', entityName: 'Lead', scopeType: 'edit' })}

${stmtCreateScope({ scopeName: 'CompanyDeals', viewName: 'CompanyDetail', entityName: 'Deal', scopeType: 'dataGrid' })}
${stmtCreateScope({
                scopeName: 'CompanyContacts',
                viewName: 'CompanyDetail',
                entityName: 'Contact',
                scopeType: 'dataGrid',
            })}
${stmtCreateScope({ scopeName: 'CompanyLeads', viewName: 'CompanyDetail', entityName: 'Lead', scopeType: 'dataGrid' })}
${stmtCreateScope({ scopeName: 'ContactDeals', viewName: 'ContactDetail', entityName: 'Deal', scopeType: 'dataGrid' })}
${stmtCreateScope({ scopeName: 'ContactLeads', viewName: 'ContactDetail', entityName: 'Lead', scopeType: 'dataGrid' })}
${stmtCreateScope({ scopeName: 'LeadContacts', viewName: 'LeadDetail', entityName: 'Contact', scopeType: 'dataGrid' })}

${stmtCreateScope({
                scopeName: 'CompanyTypes',
                viewName: 'CompanyTypes',
                entityName: 'CompanyType',
                scopeType: 'multiEdit',
            })}

${stmtCreateScope({
                scopeName: 'ContactTypes',
                viewName: 'ContactTypes',
                entityName: 'ContactType',
                scopeType: 'multiEdit',
            })}

${stmtCreateScope({ scopeName: 'DealStages', viewName: 'DealStages', entityName: 'DealStage', scopeType: 'multiEdit' })}

${stmtCreateScope({ scopeName: 'Industries', viewName: 'Industries', entityName: 'Industry', scopeType: 'multiEdit' })}

${stmtCreateScope({ scopeName: 'Sources', viewName: 'Sources', entityName: 'Source', scopeType: 'multiEdit' })}

${stmtCreateScope({ scopeName: 'Statuses', viewName: 'Statuses', entityName: 'Status', scopeType: 'multiEdit' })}

${stmtCreateScope({ scopeName: 'Countries', viewName: 'Countries', entityName: 'Country', scopeType: 'multiEdit' })}

${stmtCreateScope({ scopeName: 'UserList', viewName: 'UserList', entityName: 'User', scopeType: 'dataGrid' })}
${stmtCreateScope({ scopeName: 'UserEdit', viewName: 'UserEdit', entityName: 'User', scopeType: 'edit' })}
${stmtCreateScope({ scopeName: 'UserCreate', viewName: 'UserCreate', entityName: 'User', scopeType: 'create' })}

${stmtAddStructureColumn({ viewName: 'DealList', scopeName: 'DealList', columnName: 'name', columnType: 'text' })}

# Create CompanyForm
${stmtCreateForm({ entityName: 'Company', formName: 'CompanyForm' })}
${stmtAddStructureField({ formName: 'CompanyForm', fieldName: 'name', fieldType: 'text' })}
${stmtAddStructureField({ formName: 'CompanyForm', fieldName: 'website', fieldType: 'text' })}
${stmtAddStructureField({ formName: 'CompanyForm', fieldName: 'amountInCents', fieldType: 'number' })}
${stmtAddStructureField({ formName: 'CompanyForm', fieldName: 'email', fieldType: 'text' })}
${stmtAddStructureField({ formName: 'CompanyForm', fieldName: 'phone', fieldType: 'text' })}
${stmtAddStructureField({ formName: 'CompanyForm', fieldName: 'type', fieldType: 'select' })}
${stmtAddStructureField({ formName: 'CompanyForm', fieldName: 'industry', fieldType: 'select' })}
${stmtAddStructureField({ formName: 'CompanyForm', fieldName: 'country', fieldType: 'select' })}
${stmtAddStructureField({ formName: 'CompanyForm', fieldName: 'contacts', fieldType: 'multiselect' })}

# Connect CompanyForm to scopes
${stmtCreateForm({
                entityName: 'Company',
                formName: 'CompanyForm',
                viewName: 'CompanyCreate',
                scopeName: 'CompanyCreate',
            })}
${stmtCreateForm({ entityName: 'Company', formName: 'CompanyForm', viewName: 'CompanyEdit', scopeName: 'CompanyEdit' })}

# Create CompanyTypeForm
${stmtCreateForm({ entityName: 'CompanyType', formName: 'CompanyTypeForm' })}
${stmtAddStructureField({ formName: 'CompanyTypeForm', fieldName: 'name', fieldType: 'text' })}

# Connect CompanyTypeForm
${stmtCreateForm({
                entityName: 'CompanyType',
                formName: 'CompanyTypeForm',
                viewName: 'CompanyTypes',
                scopeName: 'CompanyTypes',
            })}

# Create ContactForm
${stmtCreateForm({ entityName: 'Contact', formName: 'ContactForm' })}
${stmtAddStructureField({ formName: 'ContactForm', fieldName: 'firstName', fieldType: 'text' })}
${stmtAddStructureField({ formName: 'ContactForm', fieldName: 'lastName', fieldType: 'text' })}
${stmtAddStructureField({ formName: 'ContactForm', fieldName: 'email', fieldType: 'text' })}
${stmtAddStructureField({ formName: 'ContactForm', fieldName: 'phone', fieldType: 'text' })}
${stmtAddStructureField({ formName: 'ContactForm', fieldName: 'birthdate', fieldType: 'date' })}
${stmtAddStructureField({ formName: 'ContactForm', fieldName: 'type', fieldType: 'select' })}
${stmtAddStructureField({ formName: 'ContactForm', fieldName: 'source', fieldType: 'select' })}
${stmtAddStructureField({ formName: 'ContactForm', fieldName: 'status', fieldType: 'select' })}
${stmtAddStructureField({ formName: 'ContactForm', fieldName: 'company', fieldType: 'select' })}
${stmtAddStructureField({ formName: 'ContactForm', fieldName: 'country', fieldType: 'select' })}

# Connect ContactForm to scopes
${stmtCreateForm({
                entityName: 'Contact',
                formName: 'ContactForm',
                viewName: 'ContactCreate',
                scopeName: 'ContactCreate',
            })}
${stmtCreateForm({ entityName: 'Contact', formName: 'ContactForm', viewName: 'ContactEdit', scopeName: 'ContactEdit' })}

# Create ContactTypeForm
${stmtCreateForm({ entityName: 'ContactType', formName: 'ContactTypeForm' })}
${stmtAddStructureField({ formName: 'ContactTypeForm', fieldName: 'name', fieldType: 'text' })}

# Connect ContactTypeForm
${stmtCreateForm({
                entityName: 'ContactType',
                formName: 'ContactTypeForm',
                viewName: 'ContactTypes',
                scopeName: 'ContactTypes',
            })}

# Create DealForm
${stmtCreateForm({ entityName: 'Deal', formName: 'DealForm' })}
${stmtAddStructureField({ formName: 'DealForm', fieldName: 'name', fieldType: 'text' })}
${stmtAddStructureField({ formName: 'DealForm', fieldName: 'amountInCents', fieldType: 'number' })}
${stmtAddStructureField({ formName: 'DealForm', fieldName: 'probability', fieldType: 'number' })}
${stmtAddStructureField({ formName: 'DealForm', fieldName: 'lead', fieldType: 'select' })}
${stmtAddStructureField({ formName: 'DealForm', fieldName: 'assignedTo', fieldType: 'multiselect' })}
${stmtAddStructureField({ formName: 'DealForm', fieldName: 'details', fieldType: 'textarea' })}
${stmtAddStructureField({ formName: 'DealForm', fieldName: 'stage', fieldType: 'select' })}
${stmtAddStructureField({ formName: 'DealForm', fieldName: 'company', fieldType: 'select' })}
${stmtAddStructureField({ formName: 'DealForm', fieldName: 'contacts', fieldType: 'multiselect' })}
${stmtAddStructureField({ formName: 'DealForm', fieldName: 'source', fieldType: 'select' })}
${stmtAddStructureField({ formName: 'DealForm', fieldName: 'files', fieldType: 'plugin' })}

# Connect DealForm to scopes
${stmtCreateForm({ entityName: 'Deal', formName: 'DealForm', viewName: 'DealCreate', scopeName: 'DealCreate' })}
${stmtCreateForm({ entityName: 'Deal', formName: 'DealForm', viewName: 'DealEdit', scopeName: 'DealEdit' })}

# Create DealStageForm
${stmtCreateForm({ entityName: 'DealStage', formName: 'DealStageForm' })}
${stmtAddStructureField({ formName: 'DealStageForm', fieldName: 'name', fieldType: 'text' })}

# Connect DealStageForm
${stmtCreateForm({
                entityName: 'DealStage',
                formName: 'DealStageForm',
                viewName: 'DealStages',
                scopeName: 'DealStages',
            })}

# Create LeadForm
${stmtCreateForm({ entityName: 'Lead', formName: 'LeadForm' })}
${stmtAddStructureField({ formName: 'LeadForm', fieldName: 'name', fieldType: 'text' })}
${stmtAddStructureField({ formName: 'LeadForm', fieldName: 'email', fieldType: 'text' })}
${stmtAddStructureField({ formName: 'LeadForm', fieldName: 'amountInCents', fieldType: 'number' })}
${stmtAddStructureField({ formName: 'LeadForm', fieldName: 'details', fieldType: 'textarea' })}
${stmtAddStructureField({ formName: 'LeadForm', fieldName: 'company', fieldType: 'select' })}
${stmtAddStructureField({ formName: 'LeadForm', fieldName: 'contacts', fieldType: 'multiselect' })}
${stmtAddStructureField({ formName: 'LeadForm', fieldName: 'source', fieldType: 'select' })}
${stmtAddStructureField({ formName: 'LeadForm', fieldName: 'status', fieldType: 'select' })}
${stmtAddStructureField({ formName: 'LeadForm', fieldName: 'assignedTo', fieldType: 'multiselect' })}

# Connect LeadForm to scopes
${stmtCreateForm({ entityName: 'Lead', formName: 'LeadForm', viewName: 'LeadCreate', scopeName: 'LeadCreate' })}
${stmtCreateForm({ entityName: 'Lead', formName: 'LeadForm', viewName: 'LeadEdit', scopeName: 'LeadEdit' })}

# Create SourceForm
${stmtCreateForm({ entityName: 'Source', formName: 'SourceForm' })}
${stmtAddStructureField({ formName: 'SourceForm', fieldName: 'name', fieldType: 'text' })}

# Connect SourceForm
${stmtCreateForm({ entityName: 'Source', formName: 'SourceForm', viewName: 'Sources', scopeName: 'Sources' })}

# Create CountryForm
${stmtCreateForm({ entityName: 'Country', formName: 'CountryForm' })}
${stmtAddStructureField({ formName: 'CountryForm', fieldName: 'name', fieldType: 'text' })}

# Connect Country
${stmtCreateForm({ entityName: 'Country', formName: 'CountryForm', viewName: 'Countries', scopeName: 'Countries' })}

# Create IndustryForm
${stmtCreateForm({ entityName: 'Industry', formName: 'IndustryForm' })}
${stmtAddStructureField({ formName: 'IndustryForm', fieldName: 'name', fieldType: 'text' })}

# Connect IndustryForm
${stmtCreateForm({ entityName: 'Industry', formName: 'IndustryForm', viewName: 'Industries', scopeName: 'Industries' })}

# Create StatusForm
${stmtCreateForm({ entityName: 'Status', formName: 'StatusForm' })}
${stmtAddStructureField({ formName: 'StatusForm', fieldName: 'name', fieldType: 'text' })}

# Connect StatusForm
${stmtCreateForm({ entityName: 'Status', formName: 'StatusForm', viewName: 'Statuses', scopeName: 'Statuses' })}

# Create UserForm
${stmtCreateForm({ entityName: 'User', formName: 'UserForm' })}
${stmtAddStructureField({ formName: 'UserForm', fieldName: 'person', fieldType: 'plugin' })}

# Connect UserForm
${stmtCreateForm({ entityName: 'User', formName: 'UserForm', viewName: 'UserCreate', scopeName: 'UserCreate' })}
${stmtCreateForm({ entityName: 'User', formName: 'UserForm', viewName: 'UserEdit', scopeName: 'UserEdit' })}

${stmtAddStructureColumn({
                viewName: 'UserList',
                columnName: 'person.tenantPerson.email',
                columnType: 'text',
                scopeName: 'UserList',
            })}

add readout UserReadout for User;
add readoutField person.email in UserReadout;

# Add inside forms to CompanyForm
${stmtCreateInsideSelectForm({ formName: 'CompanyForm', fieldName: 'type', insideFormName: 'CompanyTypeForm' })}
${stmtCreateInsideSelectForm({ formName: 'CompanyForm', fieldName: 'industry', insideFormName: 'IndustryForm' })}
${stmtCreateInsideSelectForm({ formName: 'CompanyForm', fieldName: 'country', insideFormName: 'CountryForm' })}
${stmtCreateInsideSelectForm({ formName: 'CompanyForm', fieldName: 'contacts', insideFormName: 'ContactForm' })}

# Add inside forms to ContactForm
${stmtCreateInsideSelectForm({ formName: 'ContactForm', fieldName: 'type', insideFormName: 'ContactTypeForm' })}
${stmtCreateInsideSelectForm({ formName: 'ContactForm', fieldName: 'source', insideFormName: 'SourceForm' })}
${stmtCreateInsideSelectForm({ formName: 'ContactForm', fieldName: 'status', insideFormName: 'StatusForm' })}
${stmtCreateInsideSelectForm({ formName: 'ContactForm', fieldName: 'company', insideFormName: 'CompanyForm' })}
${stmtCreateInsideSelectForm({ formName: 'ContactForm', fieldName: 'country', insideFormName: 'CountryForm' })}

# Add inside forms to DealForm
${stmtCreateInsideSelectForm({ formName: 'DealForm', fieldName: 'lead', insideFormName: 'LeadForm' })}
${stmtCreateInsideSelectForm({ formName: 'DealForm', fieldName: 'stage', insideFormName: 'DealStageForm' })}
${stmtCreateInsideSelectForm({ formName: 'DealForm', fieldName: 'company', insideFormName: 'CompanyForm' })}
${stmtCreateInsideSelectForm({ formName: 'DealForm', fieldName: 'contacts', insideFormName: 'ContactForm' })}
${stmtCreateInsideSelectForm({ formName: 'DealForm', fieldName: 'source', insideFormName: 'SourceForm' })}

# Add inside forms to LeadForm
${stmtCreateInsideSelectForm({ formName: 'LeadForm', fieldName: 'company', insideFormName: 'CompanyForm' })}
${stmtCreateInsideSelectForm({ formName: 'LeadForm', fieldName: 'contacts', insideFormName: 'ContactForm' })}
${stmtCreateInsideSelectForm({ formName: 'LeadForm', fieldName: 'source', insideFormName: 'SourceForm' })}
${stmtCreateInsideSelectForm({ formName: 'LeadForm', fieldName: 'status', insideFormName: 'StatusForm' })}

create readout CompanyReadout for Company;
add readoutField name in CompanyReadout;
add readoutField website in CompanyReadout;
add readoutField amountInCents in CompanyReadout;
add readoutField email in CompanyReadout;
add readoutField phone in CompanyReadout;
add readoutField type.name in CompanyReadout;
add readoutField industry.name in CompanyReadout;
add readoutField country.name in CompanyReadout;

# Create readout for Contact
${stmtCreateReadout({ entityName: 'Contact', readoutName: 'ContactReadout' })}
${stmtAddReadoutField({ readoutName: 'ContactReadout', readoutFieldName: 'firstName' })}
${stmtAddReadoutField({ readoutName: 'ContactReadout', readoutFieldName: 'lastName' })}
${stmtAddReadoutField({ readoutName: 'ContactReadout', readoutFieldName: 'email' })}
${stmtAddReadoutField({ readoutName: 'ContactReadout', readoutFieldName: 'phone' })}
${stmtAddReadoutField({ readoutName: 'ContactReadout', readoutFieldName: 'birthdate' })}
${stmtAddReadoutField({ readoutName: 'ContactReadout', readoutFieldName: 'type.name' })}
${stmtAddReadoutField({ readoutName: 'ContactReadout', readoutFieldName: 'source.name' })}
${stmtAddReadoutField({ readoutName: 'ContactReadout', readoutFieldName: 'status.name' })}
${stmtAddReadoutField({ readoutName: 'ContactReadout', readoutFieldName: 'company.name' })}

# Create readout for Deal
${stmtCreateReadout({ entityName: 'Deal', readoutName: 'DealReadout' })}
${stmtAddReadoutField({ readoutName: 'DealReadout', readoutFieldName: 'name' })}
${stmtAddReadoutField({ readoutName: 'DealReadout', readoutFieldName: 'amountInCents' })}
${stmtAddReadoutField({ readoutName: 'DealReadout', readoutFieldName: 'probability' })}
${stmtAddReadoutField({ readoutName: 'DealReadout', readoutFieldName: 'lead.name' })}
${stmtAddReadoutField({ readoutName: 'DealReadout', readoutFieldName: 'details' })}
${stmtAddReadoutField({ readoutName: 'DealReadout', readoutFieldName: 'stage.name' })}
${stmtAddReadoutField({ readoutName: 'DealReadout', readoutFieldName: 'company.name' })}
${stmtAddReadoutField({ readoutName: 'DealReadout', readoutFieldName: 'source.name' })}

# Create readout for Lead
${stmtCreateReadout({ entityName: 'Lead', readoutName: 'LeadReadout' })}
${stmtAddReadoutField({ readoutName: 'LeadReadout', readoutFieldName: 'name' })}
${stmtAddReadoutField({ readoutName: 'LeadReadout', readoutFieldName: 'email' })}
${stmtAddReadoutField({ readoutName: 'LeadReadout', readoutFieldName: 'amountInCents' })}
${stmtAddReadoutField({ readoutName: 'LeadReadout', readoutFieldName: 'details' })}
${stmtAddReadoutField({ readoutName: 'LeadReadout', readoutFieldName: 'company.name' })}
${stmtAddReadoutField({ readoutName: 'LeadReadout', readoutFieldName: 'source.name' })}
${stmtAddReadoutField({ readoutName: 'LeadReadout', readoutFieldName: 'status.name' })}

create preview CompanyPreview for Company;
add previewField name in CompanyPreview;
add previewField industry.name in CompanyPreview;
add previewField country.name in CompanyPreview;

create preview ContactPreview for Contact;
add previewField firstName in ContactPreview;
add previewField lastName in ContactPreview;
add previewField company.name in ContactPreview;

create preview DealPreview for Deal;
add previewField name in DealPreview;
add previewField amountInCents in DealPreview;
add previewField stage.name in DealPreview;

create preview LeadPreview for Lead;
add previewField name in LeadPreview;
add previewField company.name in LeadPreview;
add previewField status.name in LeadPreview;

${stmtAddPreview({ entityName: 'CompanyType', previewName: 'CompanyTypePreview' })}
${stmtAddPreviewField({ previewName: 'CompanyTypePreview', previewFieldName: 'name' })}

create preview IndustryPreview for Industry;
add previewField name in IndustryPreview;

create preview CountryPreview for Country;
add previewField name in CountryPreview;

create preview ContactTypePreview for ContactType;
add previewField name in ContactTypePreview;

create preview SourcePreview for Source;
add previewField name in SourcePreview;

create preview StatusPreview for Status;
add previewField name in StatusPreview;

create preview DealStagePreview for DealStage;
add previewField name in DealStagePreview;

# UserPreview
create preview UserPreview for User;
add previewField person.tenantPerson.email in UserPreview;

${stmtAddPreview({
                previewName: 'CompanyTypePreview',
                formName: 'CompanyForm',
                fieldName: 'type',
                entityName: 'CompanyType',
            })}

add preview IndustryPreview in CompanyForm.industry for Industry;
add preview CountryPreview in CompanyForm.country for Country;
add preview CompanyPreview in ContactForm.company for Company;
add preview ContactTypePreview in ContactForm.type for ContactType;
add preview SourcePreview in ContactForm.source for Source;
add preview StatusPreview in ContactForm.status for Status;
add preview CountryPreview in ContactForm.country for Country;
add preview LeadPreview in DealForm.lead for Lead;
add preview DealStagePreview in DealForm.stage for DealStage;
add preview CompanyPreview in DealForm.company for Company;
add preview ContactPreview in DealForm.contacts for Contact;
add preview SourcePreview in DealForm.source for Source;
add preview CompanyPreview in LeadForm.company for Company;
add preview ContactPreview in LeadForm.contacts for Contact;
add preview SourcePreview in LeadForm.source for Source;
add preview StatusPreview in LeadForm.status for Status;

add column name as text in CompanyList.CompanyList;
add column industry.name as text in CompanyList.CompanyList;
add column country.name as text in CompanyList.CompanyList;

add column firstName as text in ContactList.ContactList;
add column lastName as text in ContactList.ContactList;
add column company.name as text in ContactList.ContactList;

add column name as text in LeadList.LeadList;
add column company.name as text in LeadList.LeadList;
add column status.name as text in LeadList.LeadList;
add column amountInCents as number in LeadList.LeadList;

${stmtDefineClickEvent({
                eventName: 'SaveCompany',
                eventLabel: 'Save Company',
                eventPosition: 'actions',
                eventType: 'persist',
                sourceViewName: 'CompanyCreate',
            })}
define click_event UpdateCompany "Update Company" on CompanyEdit persist in actions;
define click_event SaveContact "Save Contact" on ContactCreate persist in actions;
define click_event UpdateContact "Update Contact" on ContactEdit persist in actions;
define click_event SaveDeal "Save Deal" on DealCreate persist in actions;
define click_event UpdateDeal "Update Deal" on DealEdit persist in actions;
define click_event SaveLead "Save Lead" on LeadCreate persist in actions;
define click_event UpdateLead "Update Lead" on LeadEdit persist in actions;
${stmtDefineClickEvent({
                eventName: 'SaveCompanyType',
                eventLabel: 'Save Company Type',
                eventPosition: 'actions',
                eventType: 'persist',
                sourceViewName: 'CompanyTypes',
            })}
${stmtDefineClickEvent({
                eventName: 'SaveContactTypes',
                eventLabel: 'Save Contact Type',
                eventPosition: 'actions',
                eventType: 'persist',
                sourceViewName: 'ContactTypes',
            })}
${stmtDefineClickEvent({
                eventName: 'SaveDealStage',
                eventLabel: 'Save Deal Stage',
                eventPosition: 'actions',
                eventType: 'persist',
                sourceViewName: 'DealStages',
            })}
${stmtDefineClickEvent({
                eventName: 'SaveIndustry',
                eventLabel: 'Save Industry',
                eventPosition: 'actions',
                eventType: 'persist',
                sourceViewName: 'Industries',
            })}
${stmtDefineClickEvent({
                eventName: 'SaveSource',
                eventLabel: 'Save Source',
                eventPosition: 'actions',
                eventType: 'persist',
                sourceViewName: 'Sources',
            })}
${stmtDefineClickEvent({
                eventName: 'SaveStatus',
                eventLabel: 'Save Status',
                eventPosition: 'actions',
                eventType: 'persist',
                sourceViewName: 'Statuses',
            })}
${stmtDefineClickEvent({
                eventName: 'SaveCountry',
                eventLabel: 'Save Country',
                eventPosition: 'actions',
                eventType: 'persist',
                sourceViewName: 'Countries',
            })}
${stmtDefineClickEvent({
                eventName: 'SaveUserCreate',
                eventLabel: 'Save User',
                eventPosition: 'actions',
                eventType: 'persist',
                sourceViewName: 'UserCreate',
            })}
${stmtDefineClickEvent({
                eventName: 'SaveUserEdit',
                eventLabel: 'Save User',
                eventPosition: 'actions',
                eventType: 'persist',
                sourceViewName: 'UserEdit',
            })}

define redirect_on_persist CompanyRedirectOnCreate on CompanyCreate.CompanyCreate to CompanyDetail;
define redirect_on_persist CompanyRedirectOnEdit on CompanyEdit.CompanyEdit to CompanyDetail;
define redirect_on_persist ContactRedirectOnCreate on ContactCreate.ContactCreate to ContactDetail;
define redirect_on_persist ContactRedirectOnEdit on ContactEdit.ContactEdit to ContactDetail;
define redirect_on_persist DealRedirectOnCreate on DealCreate.DealCreate to DealDetail;
define redirect_on_persist DealRedirectOnEdit on DealEdit.DealEdit to DealDetail;
define redirect_on_persist LeadRedirectOnCreate on LeadCreate.LeadCreate to LeadDetail;
define redirect_on_persist LeadRedirectOnEdit on LeadEdit.LeadEdit to LeadDetail;

define click_event ViewCompanyDetail "Details" on CompanyList.CompanyList navigate in entity to CompanyDetail;
define click_event ViewCompanyEdit "Edit" on CompanyList.CompanyList navigate in entity to CompanyEdit;
define click_event ViewCompanyCreate "Create Company" on CompanyList.CompanyList navigate in action to CompanyCreate;

define click_event EditCompany "Edit" on CompanyDetail.CompanyDetail navigate in actions to CompanyEdit;
define click_event CreateCompany "Create Company" on CompanyList navigate in actions to CompanyCreate;
define click_event ViewContactDetail "View Details" on Contacts.ContactList navigate in entity to ContactDetail;
define click_event EditContact "Edit" on ContactDetail.ContactDetail navigate in actions to ContactEdit;
define click_event CreateContact "Create Contact" on ContactList navigate in actions to ContactCreate;
define click_event EditDeal "Edit" on DealDetail.DealDetail navigate in actions to DealEdit;

${stmtDefineClickEvent({
                eventType: 'navigate',
                eventPosition: 'actions',
                eventLabel: 'Kanban',
                sourceViewName: 'DealList',
                targetViewName: 'DealBoard',
                eventName: 'DealListToDealBoard',
            })}
${stmtDefineClickEvent({
                eventType: 'navigate',
                eventPosition: 'actions',
                eventLabel: 'List',
                sourceViewName: 'DealBoard',
                targetViewName: 'DealList',
                eventName: 'DealBoardToDealList',
            })}
${stmtDefineClickEvent({
                eventType: 'navigate',
                eventPosition: 'actions',
                eventLabel: 'Create Deal',
                sourceViewName: 'DealBoard',
                targetViewName: 'DealCreate',
                eventName: 'DealBoardToDealCreate',
            })}
${stmtDefineClickEvent({
                eventType: 'navigate',
                eventPosition: 'actions',
                eventLabel: 'Create Deal',
                sourceViewName: 'DealList',
                targetViewName: 'DealCreate',
                eventName: 'DealBoardToDealCreate',
            })}

${stmtDefineClickEvent({
                eventType: 'navigate',
                eventPosition: 'actions',
                eventLabel: 'Kanban',
                sourceViewName: 'LeadList',
                targetViewName: 'LeadBoard',
                eventName: 'LeadListToLeadBoard',
            })}
${stmtDefineClickEvent({
                eventType: 'navigate',
                eventPosition: 'actions',
                eventLabel: 'List',
                sourceViewName: 'LeadBoard',
                targetViewName: 'LeadList',
                eventName: 'LeadBoardToLeadList',
            })}
${stmtDefineClickEvent({
                eventType: 'navigate',
                eventPosition: 'actions',
                eventLabel: 'Create Lead',
                sourceViewName: 'LeadBoard',
                targetViewName: 'LeadCreate',
                eventName: 'LeadBoardToLeadCreate',
            })}
${stmtDefineClickEvent({
                eventType: 'navigate',
                eventPosition: 'actions',
                eventLabel: 'Create Lead',
                sourceViewName: 'LeadList',
                targetViewName: 'LeadCreate',
                eventName: 'LeadBoardToLeadCreate',
            })}

define click_event ViewLeadDetail "View Details" on LeadList.LeadList navigate in entity to LeadDetail;
define click_event EditLead "Edit" on LeadDetail.LeadDetail navigate in actions to LeadEdit;
define click_event ViewCompanyDeals "View Deals" on CompanyDetail.CompanyDeals navigate in entity to DealDetail;
define click_event ViewCompanyContacts "View Contact" on CompanyDetail.CompanyContacts navigate in entity to ContactDetail;
define click_event ViewCompanyLeads "View Lead" on CompanyDetail.CompanyLeads navigate in entity to LeadDetail;
define click_event ViewContactDeals "View Deal" on ContactDetail.ContactDeals navigate in entity to DealDetail;
define click_event ViewContactLeads "View Lead" on ContactDetail.ContactLeads navigate in entity to LeadDetail;
define click_event ViewDealContacts "View Contact" on DealDetail.DealContacts navigate in entity to ContactDetail;
define click_event ViewLeadContacts "View Contact" on LeadDetail.LeadContacts navigate in entity to ContactDetail;

# Create navigation
${stmtCreateNavigation({ label: 'Leads', viewName: 'LeadList', icon: 'target-icon' })}
${stmtCreateNavigation({ label: 'Deals', viewName: 'DealList', icon: 'handshake-icon' })}
${stmtCreateNavigation({ label: 'Companies', viewName: 'CompanyList', icon: 'building-icon' })}
${stmtCreateNavigation({ label: 'Contacts', viewName: 'ContactList', icon: 'users-icon' })}

create navigation "User Management" to UserList with icon users-round-icon;
create navigation "Company types" to CompanyTypes with icon settings-icon;
create navigation "Contact types" to ContactTypes with icon settings-icon;
create navigation "Deal stages" to DealStages with icon settings-icon;
create navigation "Industries" to Industries with icon settings-icon;
create navigation "Sources" to Sources with icon settings-icon;
create navigation "Statuses" to Statuses with icon settings-icon;
create navigation "Countries" to Countries with icon settings-icon;

add column name as text in CompanyDetail.CompanyDeals;
add column amountInCents as number in CompanyDetail.CompanyDeals;
add column stage.name as text in CompanyDetail.CompanyDeals;
add column firstName as text in CompanyDetail.CompanyContacts;
add column lastName as text in CompanyDetail.CompanyContacts;
add column email as text in CompanyDetail.CompanyContacts;
add column name as text in CompanyDetail.CompanyLeads;
add column status.name as text in CompanyDetail.CompanyLeads;
add column amountInCents as number in CompanyDetail.CompanyLeads;

add column firstName as text in DealDetail.DealContacts;
add column lastName as text in DealDetail.DealContacts;
add column email as text in DealDetail.DealContacts;
add column phone as text in DealDetail.DealContacts;

create scope LeadDetail as detail in LeadDetail for Lead;
add readout LeadReadout in LeadDetail.LeadDetail for Lead;
add column firstName as text in LeadDetail.LeadContacts;
add column lastName as text in LeadDetail.LeadContacts;
add column email as text in LeadDetail.LeadContacts;
add column phone as text in LeadDetail.LeadContacts;

create scope ContactDetail as detail in ContactDetail for Contact;
add readout ContactReadout in ContactDetail.ContactDetail for Contact;
add column name as text in ContactDetail.ContactDeals;
add column amountInCents as number in ContactDetail.ContactDeals;
add column stage.name as text in ContactDetail.ContactDeals;
add column company.name as text in ContactDetail.ContactDeals;
add column name as text in ContactDetail.ContactLeads;
add column status.name as text in ContactDetail.ContactLeads;
add column amountInCents as number in ContactDetail.ContactLeads;

define click_event CreateUser "Create User" on UserList navigate in actions to UserCreate;
define click_event SaveUser "Save User" on UserCreate.UserCreate persist in actions;
define redirect_on_persist UserRedirectOnCreate on UserCreate.UserCreate to UserEdit;
define click_event UpdateUser "Update User" on UserEdit.UserEdit persist in actions;

add readout DealReadout in DealDetail.DealDetail for Deal;
add readout CompanyReadout in CompanyDetail.CompanyDetail for Company;

${stmtCreateScope({ scopeName: 'DealBoard', viewName: 'DealBoard', entityName: 'Deal', scopeType: 'plugin' })}
${stmtAddStructurePlugin({
                pluginName: 'board', viewName: 'DealBoard', scopeName: 'DealBoard', params: {
                    entities: 'Deal',
                    columns: 'DealStage',
                    columnsSortableBy: 'order',
                    discriminationField: 'stage',
                    sortableBy: 'order',
                    columnHeader: 'stage.name',
                    titleField: 'name',
                },
            })}

${stmtCreateScope({ scopeName: 'LeadBoard', viewName: 'LeadBoard', entityName: 'Lead', scopeType: 'plugin' })}
${stmtAddStructurePlugin({
                pluginName: 'board', viewName: 'LeadBoard', scopeName: 'LeadBoard', params: {
                    entities: 'Lead',
                    columns: 'Status',
                    columnsSortableBy: 'order',
                    discriminationField: 'status',
                    sortableBy: 'order',
                    columnHeader: 'status.name',
                    titleField: 'name',
                },
            })}

`,
        },
    },
    logs: [
        {
            create: {
                prompt: 'crm template',
                model: 'crm template',
                response: 'crm template',
                finishReason: 'crm template',
                promptTokens: 0,
                completionTokens: 0,
                totalTokens: 0,
            },
        },
    ],
};
//# sourceMappingURL=crm.js.map